<ng-container *ngIf="data as d; else noData">
    <iframe [src]="d.uri | toHttps | safeResource"></iframe>
</ng-container>

<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>

<ng-template #noData>
    <p>No data provided</p>
</ng-template>
